// @flow
import React from 'react'
import { Link } from 'react-router'
import MarketsSelect from '../components/MarketsSelect'
import VerticalSelect from '../components/VerticalSelect'
import UseCases from '../components/UseCases'
import type { OrganizationType } from '../types/OrganizationType'

const Organization = ({
  id,
  name,
  market,
  vertical,
  industry,
  useCases,
  guidelines,
  websiteUrl,
}: OrganizationType) => (
  <dl className="dl-horizontal">
    <dt><h3>Organization</h3></dt><dd />
    <dt>Organization</dt>
    <dd><Link to={`/organization/${id}`}>{name}</Link></dd>
    <dt>Website</dt>
    <dd><a target="orgwebsite" href={websiteUrl}>{websiteUrl}</a></dd>
    <dt>Org ID</dt>
    <dd><Link to={`/organization/${id}`}>{id}</Link></dd>
    <dt>Org Market</dt>
    <dd>
      <MarketsSelect value={market} id={id} />
    </dd>
    <dt>Org Vertical</dt>
    <dd>
      <VerticalSelect value={vertical} industryValue={industry} id={id} />
    </dd>
    <dt>Org Use Cases</dt>
    <dd>
      <UseCases value={useCases} id={id} />
    </dd>
    <dt>Org General Guidelines</dt>
    <dd>
      {guidelines
        ? <div dangerouslySetInnerHTML={{ __html: guidelines }} />
        : 'No Org Guidelines'}
    </dd>
  </dl>
)

export default Organization



// WEBPACK FOOTER //
// ./src/components/Organization.js